// no flow: no type decls for SimpleMde

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import SimpleMDE from 'simplemde';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { getRef, setRef } from 'app/common/utils/ReactUtils';
import 'app/common/components/SimpleMdeWrapper.scss';

const SimpleMdeWrapper = createReactClass({
  displayName: 'SimpleMdeWrapper',
  mixins: [PureRenderMixin],

  propTypes: {
    // Primitives
    editorHeight: PropTypes.number.isRequired,
    initValues: PropTypes.object,
    value: PropTypes.oneOfType([
      PropTypes.shape({
        selection: PropTypes.object,
        text: PropTypes.string,
      }),
      PropTypes.string,
    ]),
    // Callbacks
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
  },

  getDefaultProps() {
    return {
      editorHeight: 300,
    };
  },

  getInitialValues() {
    const defaultValues = {
      element: getRef(this, 'textarea'),
      spellChecker: false,
      status: false,
      height: this.props.editorHeight,
    };
    return _.defaults({}, this.props.initValues || {}, defaultValues);
  },

  onKeyDown(codeMirror, keyboardEvent) {
    if (this.props.onKeyDown) {
      this.props.onKeyDown(codeMirror, keyboardEvent);
    }
  },

  onChange(codeMirror, changeObj) {
    if (this.props.onChange) {
      this.props.onChange(codeMirror, changeObj);
    }
  },

  getTextValue() {
    const { value } = this.props;
    return _.isString(value) ? value : _.get(value, ['text'], '');
  },

  componentDidMount() {
    if (!this.smde) {
      this.smde = new SimpleMDE(this.getInitialValues()); // eslint-disable-line no-undef
      this.smde.codemirror.on('change', this.onChange);
      this.smde.codemirror.on('keydown', this.onKeyDown);

      const textValue = this.getTextValue();
      this.smde.value(textValue);
    }
  },

  componentDidUpdate() {
    if (this.smde) {
      const existingValue = this.smde.codemirror.getValue();
      const textValue = this.getTextValue();
      if (existingValue !== textValue) {
        this.smde.codemirror.setValue(textValue);
      }
    }
  },

  componentWillUnmount() {
    // As per: https://github.com/NextStepWebs/simplemde-markdown-editor#removing-simplemde-from-textarea
    if (this.smde) {
      this.smde.toTextArea();
      this.smde = null;
    }
  },

  render() {
    return (
      <textarea
        id={this.props.textAreaId}
        name={this.props.textAreaName}
        ref={setRef(this, 'textarea')}
      />
    );
  },
});

export default SimpleMdeWrapper;
